import { RefModel } from "./ref-model";
import { UserRef } from "../user/user-ref";

export class DTOModel extends RefModel {
  isReadonly?: boolean = false; // Some DTO have this field, some do not
  createdAt: Date = new Date(0, 0, 1);
  createdByUser: UserRef | null = null;
  modifiedAt?: Date | null = null;
  modifiedByUser?: UserRef | null = null;
}
